import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromActivateLicense from './reducers/activate-license.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ActivateLicenseEffects } from './effects/activate-license.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('activateLicense', fromActivateLicense.reducer),
    EffectsModule.forFeature([ActivateLicenseEffects])
  ]
})
export class ActivateLicenseModule { }
